// Needs to be in a separate file outside of widget.ts
// Otherwise circular dependency will emerge
// And application will compile incorrectly
export enum WidgetType {
  ANCHOR_STATUS_BAR = 'ANCHOR_STATUS_BAR',
  ANCHOR_STATUS_PIE = 'ANCHOR_STATUS_PIE',
  AREAS_LOG = 'AREAS_LOG',
  CONFIGURED = 'CONFIGURED',
  CONTRACTORS = 'CONTRACTORS',
  MOTIONLESS = 'MOTIONLESS',
  MAPS = 'MAPS',
  TAG_BATTERY_BAR = 'TAG_BATTERY_BAR',
  TAG_BATTERY_PIE = 'TAG_BATTERY_PIE',
  TAGS_ALL_BATTERY_BAR = 'TAGS_ALL_BATTERY_BAR',
  TAGS_ALL_BATTERY_PIE = 'TAGS_ALL_BATTERY_PIE',
  TAG_STATUS_BAR = 'TAG_STATUS_BAR',
  TAG_STATUS_PIE = 'TAG_STATUS_PIE',
  UNIDENTIFIED_ACCESS = 'UNIDENTIFIED_ACCESS',
  AREA_ATTENDANCE = 'AREA_ATTENDANCE',
  CUSTOM_NODE_STATUS_PIE = 'CUSTOM_NODE_STATUS_PIE',
}
